export default __webpack_public_path__ + "6277d7a7a54c25b2308c18241291422d.svg";